import React, { Component } from "react";
import { Manager, Reference, Popper } from "react-popper";
import type { Placement } from "@popperjs/core";
import ReactDOM from "react-dom";
import "./popperWrapper.scss";

// react-popper v2 takes modifiers as an array of named objects; v1 took a
// keyed object and the now-removed eventsEnabled / positionFixed props.
const modifiers = [
  { name: "hide", enabled: false },
  { name: "preventOverflow", enabled: false }
];

export interface PopperWrapperProps {
  /** Element the popper anchors to. */
  reference: React.ReactNode;
  /** Element rendered in the portal, positioned against the reference. */
  poppedComponent: React.ReactNode;
  placement?: Placement;
  referenceStyle?: React.CSSProperties;
  poppedComponentStyles?: React.CSSProperties;
}

export default class PopperWrapper extends Component<PopperWrapperProps> {
  render() {
    const {
      reference,
      poppedComponent,
      placement,
      referenceStyle,
      poppedComponentStyles
    } = this.props;
    return (
      <Manager>
        <Reference>
          {({ ref }) => (
            <div style={referenceStyle} ref={ref}>
              {reference}
            </div>
          )}
        </Reference>
        {ReactDOM.createPortal(
          <Popper placement={placement || "bottom"} modifiers={modifiers}>
            {({ ref, style }) => (
              <div
                ref={ref}
                style={Object.assign({}, style, poppedComponentStyles)}
                className="poppedComponent"
              >
                {poppedComponent}
              </div>
            )}
          </Popper>,
          document.body
        )}
      </Manager>
    );
  }
}
